<template>
  <Layout>
    <div class="px-2">
      <h1 class="mb-4">Downloads</h1>
      <div class="flex">
        <pt-view-table
          :data="files"
          :columns="columns"
          :loading="tableLoader"
          :row-class="classes.row"
          :header-class="classes.header"
          :column-class="classes.column"
          :tbody-class="classes.tbody"
          :thead-class="classes.thead"
          class="promo-table shadow border-t"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main';
import { CSV_LIST } from '@src/config/apiEndpoints';
import config from '@src/config';
import apiRequest from '@src/utils/apiRequest';
import { PtViewTable } from '@pathao/ui-components/esm/Table';

// import { PtPagination } from '@pathao/ui-components/esm/Pagination';

const columns = [
  {
    header: 'File Name',
    component: {
      props: ['rowData'],
      render() {
        return (
          <div class='table-cell-mobile'>
            {this.rowData.file_name}
          </div>
        );
      },
    },
  },
  {
    header: 'Action',
    component: {
      props: ['rowData'],
      render() {
        return (
          <div>
            <a class='pt-btn csv-download-button pt-btn-outline pt-btn-secondary-outline' href={this.rowData.csvUrl}>csv download</a>
          </div>
        );
      },
    },
  },
];

export default {
  name: 'CSVDownloads',
  page: {
    title: 'CSV downloads',
  },
  components: {
    Layout,
    PtViewTable,
  },
  data() {
    return {
      files: [],
      columns,
      tableLoader: false,
      classes: {
        thead: 'bg-grey-lighter w-auto md:w-full',
        tbody: 'bg-white text-center',
        row: 'border-b-4 lg:border-b border-solid border-grey-light mb-0 w-full',
        column: 'p-4 border-b lg:border-b-0', // border-r border-solid
        header: 'p-4',
      },
    };
  },
  created() {
    this.getCsvFiles();
  },
  methods: {
    getCsvFiles() {
      let payload = {
        url: CSV_LIST + '?page=1',
        method: 'GET',
      };

      let push = {
        page_num: 1,
      };
      this.$sendEvent('RS_CSVDownload', push);

      apiRequest(payload)
        .then((response) => {
          const csvFiles = response.data.csv;
          const authToken = this.$store.state.auth.token.access_token;

          for (let i = 0; i < csvFiles.length; i++) {
            csvFiles[i].csvUrl = `${config.api.csvURL}${csvFiles[i].resto}/data/${csvFiles[i].file_location}?auth=${authToken}`;
            this.files.push(csvFiles[i]);
          }
        });
    },
  },
};

</script>

<style>
  .csv-download-button {
    text-decoration: none;
  }
  .table-cell-mobile {
    padding-left: 20px;
    overflow: hidden;
  }
  /*@media (max-width: 992px) {
    .table-cell-mobile {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 20px;
    }
  }*/
</style>
